<template>
  <b-modal
    v-model="open"
    hide-header
    hide-footer
    hide-body
    hide-header-close
    body-class="modal-body"
    size="xl"
    :centered="true"
    @hidden="$emit('closeModal')"
  >
    <img
      :src="image"
      :onerror="basepath + 'uploads/avatars/no_avatar.jpg'"
      style="width: 100%;"
    >
  </b-modal>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    image: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      imageFullScreen: false
    }
  },
  computed: {
    basepath() {
      return process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PUBLIC_PATH;
    }
  }
}
</script>

<style lang="scss" scoped>

  .modal-body {
    margin: auto;
    display: block;
    padding: 0;
  }

  .modal-content {
    background: unset;
    border: unset;
  }

  .modal-backdrop {
    background: black;
    opacity: 0.7;
  }
</style>
